import ClosedQuestion from 'models/common/form/question/ClosedQuestion';

export default class SingleChoiceClosedQuestion extends ClosedQuestion {}
